<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="top-list-toolbar">
          <div>
            <h4 class="text-primary">Price List</h4>
            <ol class="breadcrumb breadcrumb-card-header">
              <li class="breadcrumb-item">
                <a href="javascript:void(0);" @click="backParent">Price List</a>
              </li>
              <li class="breadcrumb-item active">
                <span v-if="priceListGroup.id === null">New</span>
                <span v-else>
                  {{ priceListGroup.name }}
                </span>
              </li>
            </ol>
            <button type="button" @click="backParent" class="btn btn-sm btn-hard-outline-primary pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
            <button type="button" @click="updatePriceListGroup" class="btn btn-sm btn-soft-primary pull-left" v-show="priceListGroup.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
            <button type="button" @click="createPriceListGroup" class="btn btn-sm btn-soft-primary pull-left" v-show="priceListGroup.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
          </div>
        </div>
      </div>
    </div>
    <div class="card card-list">
      <div class="card-header">
        <div class="col-md-12">
          <h5 class="text-primary">
            <span v-if="priceListGroup.id === null">New</span>
            <span v-else>{{ priceListGroup.name }}</span>
          </h5>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="priceListGroup.name" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="date" class="col-sm-3 col-form-label text-left">Date</label>
              <div class="col-sm-9">
                <datetime v-model="priceListGroup.price_date" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta"></datetime>
              </div>
            </div>
            <div class="form-group row">
              <label for="description" class="col-sm-3 col-form-label text-left">Description</label>
              <div class="col-sm-9">
                <textarea v-model="priceListGroup.description" class="form-control"/>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-sm table-item">
                  <thead>
                    <th>Product</th>
                    <th>Uom</th>
                    <th>Price</th>
                    <th>#</th>
                  </thead>
                  <tbody>
                    <tr v-for="(l, index) in priceListGroup.lists" :key="l.id">
                      <td>
                        <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="l.product_no" />
                      </td>
                      <td>
                        <select v-model="l.uom_id" class="form-control">
                          <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                        </select>
                      </td>
                      <td>
                        <input class="form-control" type="text" id="price" v-model="l.price" v-money="money"/>
                      </td>
                      <td>
                        <button type="button" class="btn btn-sm btn-danger"><i class="fa fa-trash" aria-hidden="true" @click="remove(index)"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span style="cursor: pointer; color: blue;" @click="addLine">Add Line</span>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <!-- <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
        <button type="button" @click="updatePriceListGroup" class="btn btn-sm btn-primary pull-right" v-show="priceListGroup.id !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
        <button type="button" @click="createPriceListGroup" class="btn btn-sm btn-primary pull-right" v-show="priceListGroup.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button> -->
      </div>
    </div>
    <pre>{{ priceListGroup }}</pre>
  </div>
</template>

<script>
import axios from 'axios'
import { priceListGroupUrl, getHeader, priceListUrl } from '../../config'
import { mapState } from 'vuex'

export default {
  name: 'PriceListGroupForm',
  props: ['priceListGroup'],
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  methods: {
    remove: function (index) {
      var obj = this.priceListGroup.lists[index]
      if (obj.id !== undefined) {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(priceListUrl + '/' + obj.id, { headers: getHeader() })
              .then(response => {
                this.priceListGroup.lists.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
                this.$swal(
                  'Error',
                  error.response.data.message,
                  'error'
                )
              })
            console.log('delete from database')
          }
        })
      } else {
        this.priceListGroup.lists.splice(index, 1)
      }
    },
    addLine: function () {
      var obj = {
        group_id: null,
        product_no: null,
        quantity: 1,
        price: '0',
        start_date: null,
        end_date: null,
        uom_id: null
      }
      this.priceListGroup.lists.push(obj)
    },
    backParent: function () {
      this.$emit('backClicked')
    },
    async updatePriceListGroup () {
      await axios.put(priceListGroupUrl + '/' + this.priceListGroup.id, this.priceListGroup, { headers: getHeader() })
        .then(response => {
          this.$swal('Price List Group', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error!!',
            error.response.data.message,
            'error'
          )
        })
    },
    async createPriceListGroup () {
      await axios.post(priceListGroupUrl, this.priceListGroup, { headers: getHeader() })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error!!',
            error.response.data.message,
            'error'
          )
        })
    }
  },
  computed: {
    ...mapState({
      productList: state => state.products.productListAll,
      uomList: state => state.uom.uomList
    }),
    productselect: function () {
      var loop = []
      var array = this.productList
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: array[x].product_no + ' - ' + array[x].product_name,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    }
  }
}
</script>
